// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__OfBJB","scale":"Checkbox_scale___GXaS"};